/* eslint-disable react/no-danger */

type Props = {
  unsafeHtml: string;
};

function UnsafeHtml(props: Props) {
  const { unsafeHtml } = props;
  return (
    <span dangerouslySetInnerHTML={{ __html: unsafeHtml }} />
  );
}

export default UnsafeHtml;
